import React, { createContext, useContext, useState, Dispatch, SetStateAction } from 'react';

interface ViewTracker {
	source: string;
	setSource: Dispatch<SetStateAction<string>>;
	sourceId?: string;
	setSourceId: Dispatch<SetStateAction<string | undefined>>;
	sourceDetail?: string;
	setSourceDetail: Dispatch<SetStateAction<string | undefined>>;
}

const viewTrackerContext = createContext<ViewTracker | undefined>(undefined);

export const useViewTracker = () => {
	const context = useContext(viewTrackerContext);
	if (!context) {
		throw new Error('useViewTracker must be used within a ViewTrackerProvider');
	}
	return context;
}

export const ViewTrackerProvider: React.FC = ({ children }) => {
	const [source, setSource] = useState('');
	const [sourceId, setSourceId] = useState<string | undefined>();
	const [sourceDetail, setSourceDetail] = useState<string | undefined>();

	return (
		<viewTrackerContext.Provider value={{
			source,
			setSource,
			sourceId,
			setSourceId,
			sourceDetail,
			setSourceDetail
		}}>
			{children}
		</viewTrackerContext.Provider>
	);
};
